import { Injectable } from '@angular/core'

import { from, Observable } from 'rxjs'

import { AlertTriggerTypes } from '@ti/contracts'
import { Memoize } from '@ti/core/common/decorators'
import { UnifiedSensorTriggersProvider } from '@ti/shared/alerts/providers'

@Injectable()
export class TspUnifiedSensorAlertsProvider extends UnifiedSensorTriggersProvider {
  @Memoize()
  public get items$(): Observable<AlertTriggerTypes[]> {
    return from(Promise.resolve([]))
  }
}
